import { defineComponent as _defineComponent } from 'vue'
import { ETUIRoomRole, ETUISpeechMode } from '../../tui-room-core';
import AudioControl from './AudioControl.vue';
import ScreenShareControl from './ScreenShareControl/Index.vue';
import FullScreenControl from './FullScreenControl.vue';
import InviteControl from './InviteControl.vue';
import VideoControl from './VideoControl.vue';
import ManageMemberControl from './ManageMemberControl.vue';
import ChatControl from './ChatControl.vue';
import ApplyControl from './ApplyControl/Index.vue';
import MoreControl from './MoreControl.vue';
import SettingControl from './SettingControl.vue';
import EndControl from './EndControl.vue';
import Vote from './Vote.vue';
import Whiteboard from './whiteboard.vue';
import { storeToRefs } from 'pinia';
import { useBasicStore } from '../../../stores/basic';
import TUIRoomAegis from '../../utils/aegis';
import {USER_ROLE_MAJOR,USER_ROLE_STARTV} from "@/constants/localKeys";
import { ref, Ref, watch, onMounted, onBeforeUnmount } from 'vue';
import TUIRoomCore, { ETUIRoomEvents, ETUISignalStatus } from '../../tui-room-core';
// const props = defineProps({
//   roomRef: HTMLElement,
// });

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['on-destroy-room', 'on-exit-room'],
  setup(__props, { emit }) {

const basicStore = useBasicStore();

const {userId, liveStageRoom, userRole,roomId } = storeToRefs(basicStore);


const onDestroyRoom = (info: { code: number; message: string, data:any }) => {
  emit('on-destroy-room', info);
  TUIRoomAegis.reportEvent({ name: 'destroyRoom', ext1: 'destroyRoom-success' });
};

const onExitRoom = (info: { code: number; message: string, data:any }) => {
  emit('on-exit-room', info);
  TUIRoomAegis.reportEvent({ name: 'exitRoom', ext1: 'exitRoom-success' });
};

function report(name: string) {
  TUIRoomAegis.reportEvent({ name, ext1: name });
}

const shows=ref(false)

async function onGrantAnchor(event:any) {
  if (event.mute){
    shows.value=true
    }else{
      shows.value=false
    }
  
}

onMounted(() => {
  TUIRoomCore.on(ETUIRoomEvents.onGrantAnchor, onGrantAnchor);
  
});

onBeforeUnmount(() => {
  TUIRoomCore.off(ETUIRoomEvents.onGrantAnchor, onGrantAnchor)
});

return { __sfc: true,basicStore, userId, liveStageRoom, userRole, roomId, emit, onDestroyRoom, onExitRoom, report, shows, onGrantAnchor, ETUISpeechMode, AudioControl, ScreenShareControl, FullScreenControl, VideoControl, ApplyControl, SettingControl, EndControl, Vote, USER_ROLE_MAJOR }
}

})